<template>
  <div id="video_model">
    <div id="video_bg">
      <div style="width: 100%; height: 75%; position: relative">
        <div class="cutBtn" @click="setShow" style="top:3%">
          <a-icon type="close" />
        </div>
        <div class="cutBtn" @click="cutBtn">
          <img style="width: 30px" src="@/assets/video_modal/cut.png" alt="" />
          添加截屏
        </div>
        <!-- <div class="cutBtn" @click="setCheck" style="top:60%">
          <img style="width: 30px" src="@/assets/video_modal/cut.png" alt="" />
          提交审核
        </div> -->
        <!-- <video id="video" controls src="https://zy-script.obs.cn-south-1.myhuaweicloud.com:443/LARP/118/enterprise/1631171486887382-副本(5).mp4"> -->
        <video id="video" ref="videoBox" controls crossOrigin="anonymous" >
          <source :src="dealVideoUrl" type="video/mp4">
        </video>
      </div>
      <ul id="cutList">
        <a-empty v-if="!items.item.check_info.length" style="margin:auto" description="暂无审核内容" />
        <li v-for="(item,index) in items.item.check_info">
        <!-- <li v-for="index in 12"> -->
          <div class="img_mask" >
            <div>
              <div style="text-align:left;padding:0 10px">
                <p>异常类型：{{item.unusual_type_name}}</p>
                <p>备注内容：{{item.note}}</p>
              </div>
              <br>
              <a-icon class="cu" @click="$parent.preview(item.content_html)" :style="{ fontSize: '26px' }" type="eye" />
              <!-- <a-icon class="cu" @click="$parent.showModal(3, items.item, 'edit',index,items.index,false)" :style="{ fontSize: '26px' }" style="margin:0 15px" type="form" /> -->
              <!-- <a-icon class="cu" v-if="!item.is_show" @click="delBtn(item)" :style="{ fontSize: '26px' }" type="delete" /> -->
            </div>
          </div>
          <!-- <img
            :src="item.content"
            alt=""
          /> -->
          <img
            :src="item.content_html"
            alt=""
          />
          <!-- https://zy-script.obs.cn-south-1.myhuaweicloud.com:443/LARP/358/enterprise/ailisfengmian.jpg -->
        </li>
        
      </ul>
      <div class="cur_canvas_container">
        <canvas ref="canvas" class="cur_canvas"></canvas>
      </div>
    </div>
  </div>
</template>
<script>
import {
  category,
  check_content,
  del_check_info,
  save_edit_content,
} from "@/api/organization";
import bus from "../bus.js"
export default {
  name: "",
  props:{
    isShow:{
      type:Boolean,
      default:false
    },
    videoUrl:{
      type:String,
      default:"https://zy-script.obs.cn-south-1.myhuaweicloud.com:443/LARP/118/enterprise/1631171486887382-副本(5).mp4"
    },
    video_item:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {
        cutFile:"",
        items:this.video_item
    };
  },
  computed:{
    // 2.防止命中缓存
    dealVideoUrl () {
      return this.videoUrl + '?time=' + new Date().valueOf()
    }
  },
  created() {
    console.log(this.items)
  },
  mounted() {
    // this.$nextTick(()=>{
    //   let video = document.getElementById("video");
    //   video.src = this.videoUrl
    // })
  },
  methods: {
    //返回父组件显示状态
    setShow(){
      this.$emit("setShow",false)
    },
    //切片按钮
    cutBtn() {
      this.$refs.videoBox.pause()
      // alert(index);
      let scale = 0.25;
      let video = document.getElementById("video");
      let canvas = document.createElement("canvas");
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      canvas.setAttribute("id", "canvas");
      video.setAttribute("crossOrigin","anonymous")
      canvas
        .getContext("2d")
        .drawImage(video, 0, 0, canvas.width, canvas.height);
      
      let src = canvas.toDataURL();
      let imgObj = new Image();
      imgObj.src = src; // 可以得到一个image对象
      canvas.toBlob((blob) => {
        imgObj.file = blob; // blob 文件可以通过formData格式传参直接上传服务器
        var url = URL.createObjectURL(blob); // 用于URL的File对象，Blob对象。
        // imgObj.file.name = 
        // imgObj.file.url = url
        console.log(imgObj.file);
        console.log(url);
        // var file = new File([blob], "审核文件.png", {type: contentType, lastModified: Date.now()})
        this.cutFile = imgObj.file
        this.items.item.files = imgObj.file
        const items = this.items
        this.$parent.showModal(3, items.item, items.type, items.index)
      });
      
      //   console.log("imgUrl", canvas.toBlob("image/png", encoderOptions));
      // document.getElementById("imgOut").append(canvas);
    },

    //修改完成后的改动
    editCheck_info(index,val){
      console.log("我接收到了",index,val)
      this.items.item.check_info[index] = val
      this.$forceUpdate()
    },

    //删除方法
    delBtn(item){
      return bus.$emit('getDelFun',item)
    },
  },
};
</script>
<style lang='less' scoped>
#video_model{
  position: fixed;
  z-index: 1000;
  width: 100%;
  height: 100%;
  
}
#video_bg {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  
}
#video {
  width: 100%;
  height: 100%;
  // height: calc(100% - 35px);
  // background-color: #333;
}

.cutBtn {
  position: absolute;
  z-index: 10001;
  top: 45%;
  right: 1%;
  background-color: #171b2734;
  border-radius: 10px;
  color: #fff;
  padding: 10px 15px;
  cursor: pointer;
  img {
    width: 30px;
    height: 30px;
    margin: 0 10px;
  }
}
#cutList {
  height: 25%;
  display: flex;
  overflow-x: auto;
  padding: 10px 15px;
  background-color: #fff;
  li{
    position: relative;
    display: flex;
    img {
    height: 100%;
    margin: auto 10px;
  }
  .img_mask{
    position: absolute;
    width: calc(100% - 20px);
    margin: auto 10px;
    height: 100%;
    text-align:center;
    display: flex;
    background-color: rgba(0, 0, 0, 0.45);
    z-index: 2;
    color: #fff;
    div{
      margin: auto;
    }
  }
  }
}

.cu{
  cursor: pointer;
}

#cutList::-webkit-scrollbar {
  height: 12px;
  background-color: #ccc;
}

#cutList::-webkit-scrollbar-thumb {
  background-color: #a8a8a8;
  border-radius: 10px;
}
</style>